import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewFour',
  templateUrl: './viewFour.component.html',
  styleUrls: ['./viewFour.component.css']
})
export class ViewFourComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
